import { Helmet } from "react-helmet-async";

const SITE_NAME = "HESHAURA";
const DEFAULT_DESC =
  "HESHAURA — Bracelets for a Brighter You. A premium Indian bracelet-only brand: everyday, minimal, charm, tennis, pearl and festive bracelets, hand-finished in small batches.";

const PROD_SITE_URL = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
export const siteOrigin = () =>
  PROD_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");

// Preview / non-production hosts are never indexable.
export const isIndexable = () => {
  if (process.env.REACT_APP_SEO_INDEXABLE === "true") return true;
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  return !(host.includes("preview.emergentagent.com") || host === "localhost" || host.endsWith(".local"));
};

export const MUSE = "Heena";

export const Seo = ({ title, description = DEFAULT_DESC, path = "/", image, type = "website", jsonLd, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Handcrafted Bracelets · A Piece of Soul. A Part of Your Aura.`;
  const canonical = `${siteOrigin()}${path}`;
  const ogImage = image || `${siteOrigin()}/brand/og-image.jpg`;
  const robots = !noindex && isIndexable() ? "index,follow" : "noindex,nofollow";
  const blocks = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export const organizationLd = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: `${siteOrigin()}/`,
  description: DEFAULT_DESC,
});

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${siteOrigin()}${it.path}`,
  })),
});

export const productLd = (p, imageUrls, categoryLabel) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: p.name,
  description: p.short_description || `${p.name} — a handcrafted ${categoryLabel || "bracelet"} by HESHAURA.`,
  image: imageUrls,
  sku: p.sku || undefined,
  brand: { "@type": "Brand", name: SITE_NAME },
  category: categoryLabel,
  url: `${siteOrigin()}/product/${p.slug}`,
  offers: {
    "@type": "Offer",
    priceCurrency: "INR",
    price: p.price,
    url: `${siteOrigin()}/product/${p.slug}`,
    availability: p.stock > 0 ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
    itemCondition: "https://schema.org/NewCondition",
  },
});

export const itemListLd = (products, name) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name,
  numberOfItems: products.length,
  itemListElement: products.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: p.name,
    url: `${siteOrigin()}/product/${p.slug}`,
  })),
});
